import React from 'react'
import styled from 'styled-components'

const Input = styled.input`
  margin-right: 8px;
`

const Checkbox = ({ id, checked, onChange }) => (
  <Input id={id} type="checkbox" checked={checked} onChange={onChange} />
)

export default Checkbox



// WEBPACK FOOTER //
// ./src/components/form/Checkbox.js